module.exports = {
    message: {
        language: "zh",
        title: '账号注销提醒',
        contentData: [
            {
                title: '注销账号适用于什么情况',
                valueArr: ['1.不再使用此App', '2.不再使用此手机号或邮箱'],
            },
            {
                title: '注销此账号将会导致',
                valueArr: ['1.无法使用原账号绑定的手机号、邮箱继续登录账号', '2.原账号绑定的设备已全部解绑(如需要继续使用，请注册后重新添加)','3.账号注销之后将清空所有信息和数据' ],
            },
            {
                title: '注销关联的服务',
                valueArr: ['1.注销账号后，此账号购买的云存储服务失效，无法退款'],
            },
        ],
        logoutAccount: '注销账号',
        account: '账号',
        accountMsg: '请填写账号',
        password: '密码',
        passwordMsg: '请填写密码',
        logout: '注销',
        tips: '提示',
        confirmMsg: '您的账户注销之后将清空所有信息和数据，确定要注销吗？',
        logoutSuccess: '注销成功',
        logoutFail: '注销失败',
    }
}